import { render, staticRenderFns } from "./_article.vue?vue&type=template&id=2ff9a5f0&scoped=true&"
import script from "./_article.vue?vue&type=script&lang=js&"
export * from "./_article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9a5f0",
  null
  
)

export default component.exports